/**
 * Evessio REST API
 */
import { evessioHttpService } from "./digitalEventHTTPs";
import { getPaginationObject } from "@/helpers/helpers";

export default {
  /**
   * Get ContentNode context bu UUID
   * @param {String} uuid
   * @param {Integer} [includeChildren]
   * @param {Array} [exclude]
   * @return {Promise<>}
   */
  async getContentNodeContext({ uuid, includeChildren, exclude }) {
    return await evessioHttpService.get(`api/node/${uuid}/context`, {
      params: {
        include_children: includeChildren || 0,
        exclude: exclude || []
      }
    });
  },

  /**
   * Get content node config
   * @param {String} uuid
   * @return {Promise<>}
   */
  async getContentNodeConfig(uuid) {
    return await evessioHttpService.get(`api/node/${uuid}/config`);
  },

  /**
   * Create DigitalEventTable
   * @param tableData {Object}
   * @return {Promise<any>}
   */
  async createTable({ tableData }) {
    return await evessioHttpService.post("api/digital_event/tables/assignments/attendee", tableData);
  },

  /**
   * Update DigitalEventTable
   * @param tableUUID {String} DigitalEventTable.uuid
   * @param data {Object}
   * @return {Promise<any>}
   */
  async updateTable({ tableUUID, data }) {
    return await evessioHttpService.put(`api/digital_event/tables/${tableUUID}`, data);
  },

  /**
   * Get DigitalEventTableAssignment List
   * @param roomUUID {String} ContentNode.uuid (DigitalEventRoom CT)
   * @return {Promise<any>}
   */
  async getAssignments({ roomUUID }) {
    return await evessioHttpService.get("api/digital_event/tables/assignments", {
      params: { room_uuid: roomUUID }
    });
  },

  async createAssignment({ assignmentData }) {
    return await evessioHttpService.post("api/digital_event/tables/assignments", assignmentData);
  },

  /**
   * Update DigitalEventTableAssignment
   * @param assignmentId {Integer} DigitalEventTableAssignment.id
   * @param data {Object} Dict with params
   * @return {Promise<any>}
   */
  async updateAssignment({ assignmentId, data }) {
    return await evessioHttpService.put(`api/digital_event/tables/assignments/${assignmentId}`, data);
  },

  /**
   * Change User Table
   * @param data {Object}
   * @return {Promise<AxiosResponse<any>>}
   */
  async changeUserTable(data) {
    return await evessioHttpService.post("api/digital_event/move/user", data);
  },

  /**
   * Update User profile data
   * @param user_uuid
   * @param data
   * @return {Promise<AxiosResponse<any>>}
   */
  async updateUserProfile(data) {
    return await evessioHttpService.put(`api/user/${data.userUUID}/profile`, data.data);
  },

  /**
   * Create Photo Gallery Post
   * @param data
   * @return {Promise<AxiosResponse<any>>}
   */
  async createGalleryPost(data) {
    return await evessioHttpService.post(
      `/api/digital_event/${data.event_uuid}/room/${data.room_uuid}/posts`,
      data.postData
    );
  },
  /**
   * Get Photo Gallery Posts
   * @param data
   * @return {Promise<AxiosResponse<any>>}
   */
  async getGalleryPosts(data) {
    return await evessioHttpService.get(`/api/digital_event/${data.event_uuid}/room/${data.room_uuid}/posts`, {
      params: {
        pagination: getPaginationObject(data.limit)
      }
    });
  },
  /**
   * Get My Photo Gallery Posts
   * @param data
   * @return {Promise<AxiosResponse<any>>}
   */
  async getMyGalleryPosts(data) {
    return await evessioHttpService.get(`/api/digital_event/${data.event_uuid}/room/${data.room_uuid}/posts`, {
      params: {
        type: "personal",
        pagination: getPaginationObject(data.limit)
      }
    });
  },
  /**
   * Update Photo Gallery Post
   * @param data
   * @return {Promise<AxiosResponse<any>>}
   */
  async updateGalleryPost(data) {
    return await evessioHttpService.put(
      `/api/digital_event/${data.event_uuid}/room/${data.room_uuid}/posts/${data.card_uuid}`,
      data.postData
    );
  },
  /**
   * Delete Photo Gallery Post
   * @param data
   * @return {Promise<AxiosResponse<any>>}
   */
  async deleteGalleryPost(data) {
    return await evessioHttpService.delete(
      `/api/digital_event/${data.event_uuid}/room/${data.room_uuid}/posts/${data.card_uuid}`
    );
  },
  /**
   * Ban user
   * @param userUUID {String}
   * @return {Promise<AxiosResponse<any>>}
   */
  async banUser({ userUUID, eventUUID }) {
    return await evessioHttpService.put(`api/user/${userUUID}/ban`, null, {
      params: {
        content_node_uuid: eventUUID
      }
    });
  },
  /**
   * Restore user
   * @param userUUID {String}
   * @return {Promise<AxiosResponse<any>>}
   */
  async restoreUser({ userUUID, eventUUID }) {
    return await evessioHttpService.delete(`api/user/${userUUID}/ban`, {
      params: {
        content_node_uuid: eventUUID
      }
    });
  },
  /**
   * Get rooms
   * @param event_uuid {String}
   * @return {Promise<AxiosResponse<any>>}
   */
  async getRooms(event_uuid) {
    return await evessioHttpService.get(`/api/digital_event/${event_uuid}/rooms`);
  }
};
